import { markRaw } from 'vue'
import AccountsGraphqlFilter from '@/components/GraphqlDataTable/filters/accounts/AccountsGraphqlFilter.vue'
import WorkersGraphqlFilter from '@/components/GraphqlDataTable/filters/accounts/WorkersGraphqlFilter.vue'
import CompaniesGraphqlFilter from '@/components/GraphqlDataTable/filters/accounts/CompaniesGraphqlFilter.vue'
import DateRangeFilter from '@/components/GraphqlDataTable/filters/Dates/DateRangeFilter.vue'
import ExternalIdentifiersGraphqlFilter from '@/components/GraphqlDataTable/filters/hires/ExternalIdentifiersGraphqlFilter.vue'
import StatusGraphqlFilter from './hires/StatusGraphqlFilter.vue'
import OwnersGraphqlFilter from '@/components/GraphqlDataTable/filters/accounts/OwnersGraphqlFilter.vue'
import BooleanComp from '@/components/GraphqlDataTable/filters/Primitives/Boolean.vue'
import { FilterMaps } from '@/components/GraphqlDataTable/filters/types'
import { FilterGroups } from '@/components/GraphqlDataTable/filters/filter-enums'
import Skills from '@/components/GraphqlDataTable/filters/Primitives/Skills.vue'
import CustomFields from '@/components/GraphqlDataTable/filters/CustomFields/CustomFields.vue'
import AssociationGraphqlFilter from '@/components/GraphqlDataTable/filters/job/AssociationGraphqlFilter.vue'
import LocationPreferencesGraphqlFilter from '@/components/GraphqlDataTable/filters/job/LocationPreferencesGraphqlFilter.vue'

// Register filters here with one of two key types:
// GraphQLDataType: markRaw(GraphQLDataTypeFilterComponent)
// or $argumentName-argumentType: markRaw(ComplexFilterComponent)
// Sometimes filters can be generated on the fly or there already exists a version using a different argument name
// check them over before making a new account.
export default {
  'accounts-[ID!]': {
    component: markRaw(AccountsGraphqlFilter),
    group: FilterGroups.Default,
  },
  'companies-[ID!]': {
    component: markRaw(CompaniesGraphqlFilter),
    group: FilterGroups.Default,
  },
  DateRangeInput: {
    component: markRaw(DateRangeFilter),
    group: FilterGroups.Default,
  },
  'workers-[ID!]': {
    component: markRaw(WorkersGraphqlFilter),
    group: FilterGroups.Default,
  },
  'externalIdentifiers-[String!]': {
    component: markRaw(ExternalIdentifiersGraphqlFilter),
    group: FilterGroups.Default,
  },
  'activeStatus-[HireActiveStatus!]': {
    component: markRaw(StatusGraphqlFilter),
    group: FilterGroups.Default,
  },
  'jobOwners-[ID!]': {
    component: markRaw(OwnersGraphqlFilter),
    group: FilterGroups.Default,
  },
  'hireOwners-[ID!]': {
    component: markRaw(OwnersGraphqlFilter),
    group: FilterGroups.Default,
  },
  Boolean: {
    component: markRaw(BooleanComp),
    group: FilterGroups.Default,
  },
  '[Currency!]': {
    group: FilterGroups.Details,
  },
  '[RateType!]': {
    group: FilterGroups.Details,
  },
  'completed-Boolean': {
    group: FilterGroups.Default,
  },
  '[Association!]': {
    component: markRaw(AssociationGraphqlFilter),
    group: FilterGroups.Details,
  },
  '[LocationPreference!]': {
    component: markRaw(LocationPreferencesGraphqlFilter),
    group: FilterGroups.Details,
  },
  'skills-[String!]': {
    component: markRaw(Skills),
    group: FilterGroups.Details,
  },
  '[ExpectedExperienceLevel!]': {
    group: FilterGroups.Details,
  },
  '[CustomFieldTypeValueInput!]': {
    group: FilterGroups.NoGroup,
    component: markRaw(CustomFields),
  },
} satisfies FilterMaps as FilterMaps
